import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetIBWalletDetailsApi = () => api.get('ibusermaster/ib-wallet-details');
export const WithdrawIBCommissionApi = (data) => api.post('ibusermaster/ib-wallet-withdraw-request', data);
export const GetIBWalletRequestListApi = (params) => api.get(`ibusermaster/get-ib-wallet-withdraw-request?${qs(params)}`);